export default "/images/6f832c998affde9ee6c16cc7736c0f54.avif";